import React from "react";
import { Link } from "react-router-dom";
import { AiFillGithub } from "react-icons/ai";

const Projects = () => {
  const projects = [
    {
      serial: "01",
      name: "Hand Me Down",
      type: "e-commerce",
      href: "https://hand-me-down-e8b07.web.app/",
      image: "https://i.ibb.co/s9zDsPT/Screenshot-63.png",
      features: ` Buy and sell used products,
             Verify seller as admin,
            Register as buyer or seller,
            Add or delete product as seller`,
    },
    {
      serial: "02",
      name: "Pass Comments",
      type: "review",
      href: "https://pass-comments.web.app/",
      image: "https://i.ibb.co/f9DBYh8/Screenshot-64.png",
      features: ` Add review of services,
             Create account to add review,
            Read blogs,
            Add new services`,
    },
    {
      serial: "03",
      name: "Programming Sensei",
      type: "educational",
      href: "https://pass-comments.web.app/",
      image: "https://i.ibb.co/vDqSLfJ/Screenshot-65.png",
      features: `
                         Explore multiple classes,
                         Choose from different courses,
                        Create account to checkout,
                        Read blogs
                    `,
    },
  ];

  return (
    <div id="projects">
      <div className='md:flex md:flex-row flex flex-col-reverse justify-center gap-10 md:gap-28 md:bg-[url("/src/projectbg.png")] md:p-10 projects'>
        <div className='md:w-[700px] bg-[url("/src/projectbg.png")] md:bg-none'>
          {projects.map((project) => (
            <div key={project.serial}>
              <div className="mb-20 shadow-lg project" data-aos="zoom-in-left">
                <img src={project.image} alt="" className="mt-10 rounded-lg" />
                <div className="-mt-20">
                  <Link to={`/projects/${project.serial}`}>
                    <button className="px-6 py-2 rounded-3xl git-button btn">
                      Details
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="mb-8 md:mb-0">
          <h1 className="header text-7xl md:text-start">Project</h1>
          <h2 className="about font-extrabold md:text-7xl text-4xl">
            PORTFOLIO
          </h2>
          <p className=" w-80 mx-auto text-start mt-5 features text-lg">
            These are my top 3 full-stack projects which developed for the last
            three months. I am still updating this sites if needed. I hope to
            develop more advanced website with extra features in the future. You
            can also check my github.
          </p>
          <a href="https://github.com/nusrat-git" target="blank">
            <button className="px-6 pb-2 pt-3 md:ml-3 mx-auto rounded-3xl mt-6 mb-3 git-button flex justify-center gap-2 ">
              <AiFillGithub className="mt-0.5"></AiFillGithub>
              <span>GITHUB</span>
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Projects;
